import axios from 'axios';
import { get, includes } from 'lodash';
import state from '../redux';
import authAction from '../redux/auth/action';
import funcRefreshToken from 'helpers/refreshToken';
import { allowedRoles } from 'constants/globalVariable';
import oAuth from 'providers/auth';

const interceptor = axios.create();

//handling request, validate token
//@: https://github.com/axios/axios/issues/2315
// Request interceptor for API calls
interceptor.interceptors.request.use(
  async (config) => {
    let serverCallUrl = new URL(config.url);

    if (includes(get(serverCallUrl, 'pathname', ''), '/auth')) {
      // return config
      return config;
    }
    const { auth = {} } = state.getState();

    let accessToken = auth?.access_token;
    config.headers['Authorization'] = `Bearer ${accessToken}`;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// Function untuk handle logout pada error 403
const handleLogoutOn403 = async () => {
  try {
    await oAuth.logout().then(() => {
      localStorage.clear();
      //   window.location.replace('/login');
    });
  } catch (error) {
    console.error('Error during logout:', error);
    // Fallback jika logout gagal, tetap redirect ke login
    localStorage.clear();
    window.location.replace('/login');
  }
};

// Response interceptor for API calls
interceptor.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    const originalRequest = err.config;
    if (err.response === undefined) {
      const err = {
        message: 'Something went wrong!',
      };
      return Promise.reject(err);
    }

    if (err.response.status === 403) {
      // Cek apakah role tidak diizinkan
      if (!allowedRoles?.includes(originalRequest.headers['Authorization'])) {
        // Tampilkan pesan error dengan informasi redirect
        const errorMessage = {
          status: 'denied',
          message:
            'Mohon maaf Anda tidak memiliki akses. Aplikasi akan diarahkan ke halaman login.',
        };

        // Lakukan logout dan redirect
        setTimeout(() => {
          handleLogoutOn403();
        }, 2000);

        return Promise.reject(errorMessage);
      }
    }

    if (err.response.status === 401) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            return axios(originalRequest);
          })
          .catch(async (err) => {
            window.location.replace('/login');
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;
      return new Promise(function (resolve, reject) {
        funcRefreshToken()
          // eslint-disable-next-line no-loop-func
          .then((res) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + res;
            processQueue(null, res);
            resolve(axios(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            authAction.validatingToken(false);
            authAction.clearAuth();
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(err);
  }
);

export default interceptor;
